import { apiClient } from './apiClient';
import type { DashboardChartSlice } from './dashboardApi';

export type AreaDashboardKpi = {
  code: string;
  label: string;
  value: string;
  hint?: string;
};

export type AreaDashboardTask = {
  id: string;
  source: string;
  title: string;
  subtitle?: string;
  status: string;
  assigneeName?: string;
  dueAtUtc?: string;
  isOverdue: boolean;
  deepLink: string;
};

export type AreaDashboard = {
  areaCode: string;
  areaName: string;
  scopeKind: string;
  scopeLabel: string;
  kpis: AreaDashboardKpi[];
  charts: DashboardChartSlice[];
  tasks: AreaDashboardTask[];
  generatedAtUtc: string;
};

export type AreaDashboardKey =
  | 'commercial'
  | 'operations'
  | 'marketing'
  | 'people'
  | 'customer-success'
  | 'relationship';

const AREA_ENDPOINTS: Record<AreaDashboardKey, string> = {
  commercial: '/v1/dashboard/areas/commercial',
  operations: '/v1/dashboard/areas/operations',
  marketing: '/v1/dashboard/areas/marketing',
  people: '/v1/dashboard/areas/people',
  'customer-success': '/v1/dashboard/areas/customer-success',
  relationship: '/v1/dashboard/areas/relationship',
};

export async function fetchAreaDashboard(area: AreaDashboardKey): Promise<AreaDashboard> {
  const response = await apiClient.get<AreaDashboard>(AREA_ENDPOINTS[area]);
  return response.data;
}
